// extracted by mini-css-extract-plugin
export default {"target_product":"v3","retake":"w3","product_info":"x3","icon":"y3","target_image":"z3","background":"A3","product_info_desktop":"B3","info":"C3","title":"E3","benefits":"F3","benefit":"G3","accordeon_wrapper":"H3","ingredients_wrapper":"I3","info_wrapper":"J3","product_wrapper":"K3"};
    if(module.hot) {
      // 1714654899917
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  